import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/popover/demos/_index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/InstallationBlock/InstallationBlock.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager", webpackExports: ["ViewSourceLink"] */ "/opt/build/repo/docs/src/components/Subtitle/ViewSourceLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.42_@types+react@19.3.0_next@16.3.4_@babel+core@7_a3c696e73efb3246f95ca9ffa03a1f00/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useCodeFallback"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.42_@types+react@19.3.0_next@16.3.4_@babel+core@7_a3c696e73efb3246f95ca9ffa03a1f00/node_modules/@mui/internal-docs-infra/CodeHighlighter/useCodeFallback.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CoordinatedLazyClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.12.1-canary.42_@types+react@19.3.0_next@16.3.4_@babel+core@7_a3c696e73efb3246f95ca9ffa03a1f00/node_modules/@mui/internal-docs-infra/CoordinatedLazy/CoordinatedLazyClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.3.4_@babel+core@7.29.7_supports-color@10.2.2__@playwright+test@1.62.1_@types+no_fc5502943f7231de320c7f4fe0795a0e/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverArrow"] */ "/opt/build/repo/packages/react/src/popover/arrow/PopoverArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverBackdrop"] */ "/opt/build/repo/packages/react/src/popover/backdrop/PopoverBackdrop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverClose"] */ "/opt/build/repo/packages/react/src/popover/close/PopoverClose.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverDescription"] */ "/opt/build/repo/packages/react/src/popover/description/PopoverDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverPopup"] */ "/opt/build/repo/packages/react/src/popover/popup/PopoverPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverPortal"] */ "/opt/build/repo/packages/react/src/popover/portal/PopoverPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverPositioner"] */ "/opt/build/repo/packages/react/src/popover/positioner/PopoverPositioner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverRoot"] */ "/opt/build/repo/packages/react/src/popover/root/PopoverRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["createNullPopoverStore"] */ "/opt/build/repo/packages/react/src/popover/store/PopoverStore.ts");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverTitle"] */ "/opt/build/repo/packages/react/src/popover/title/PopoverTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverTrigger"] */ "/opt/build/repo/packages/react/src/popover/trigger/PopoverTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopoverViewport"] */ "/opt/build/repo/packages/react/src/popover/viewport/PopoverViewport.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/useAnimationFrame.ts");
